$('#benefitsCarousel').owlCarousel({
    center: false,
    items: 1,
    loop: false,
    margin: 0,
    dots: false
});

$('#benefitsNext').click(function () {
    $('#benefitsCarousel').trigger('next.owl.carousel');
});
$('#benefitsPrev').click(function () {
    $('#benefitsCarousel').trigger('prev.owl.carousel');
});

$('.benefits__carousel-item-play-video').on('click', function () {
    $(this).next('video').trigger('play').prop('controls',true);
    $(this).hide();
});